// libs
import { styled } from '@nykaa/ui-components';

export const Container = styled.div`
  position: relative;
  ${({ theme }) => theme.typography.bodyXSmall};
  ${({ theme }) => `
    padding: 0 0 0 ${theme.spacing.spacing40};
    margin-top: ${theme.spacing.spacing20};
  `};
`;

export const Pipe = styled.div<{ color: string }>`
  position: absolute;
  left: 0;
  height: 12px;
  ${({ color }) => color && `background : ${color};`}
  ${({ theme }) =>
    `border-radius: ${theme.spacing.spacing10};
    width: ${theme.spacing.spacing10};
  `};
`;

export const Title = styled.div`
  ${({ theme }) => `line-height: ${theme.spacing.spacing60};`};
`;

export const Text = styled.div<{ color: string }>`
  ${({ color }) => color && `color: ${color};`};
`;
